
import { computed, defineComponent, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { hasFeature } from "@/core/helpers/feature";

export default defineComponent({
  name: "account-base",
  components: {},
  setup() {
    const store = useStore();
    const { t } = useI18n();
    const user = computed(() => store.getters.currentUser);

    onMounted(() => {
      store.dispatch(Actions.GET_ACCOUNT_PROFILE);
    });
    const currentLanguage = computed(() => store.getters.getCurrentLanguage || localStorage.getItem('currentLanguage'));

    // Elite se QUALQUER plano/assinatura do usuário for Elite. O backend já agrega
    // isso em is_elite / features, então basta olhar esses dois sinais.
    const isElite = computed(() => hasFeature('elite') || Boolean(user.value?.is_elite));

    const progressToNextLevelPercent = computed(() => {
      const u = user.value as { user_patent?: { progress_to_next_rank_percentage?: number; current_rank_min?: number; current_rank_max?: number }; score?: { value: number } } | undefined;
      const patent = u?.user_patent;
      if (patent?.progress_to_next_rank_percentage != null) {
        return patent.progress_to_next_rank_percentage;
      }
      const min = patent?.current_rank_min;
      const max = patent?.current_rank_max;
      const value = u?.score?.value;
      if (min != null && max != null && value != null && max > min) {
        return Math.round(((value - min) / (max - min)) * 100);
      }
      if (value != null) {
        return Math.round(((value % 1000) * 100) / 1000);
      }
      return 0;
    });

    const PATENTS_ORDER = [
      { key: 'recruit', icon: 'recruta.png', max: 1999 },
      { key: 'soldier', icon: 'soldado.png', max: 3999 },
      { key: 'cable', icon: 'cabo.png', max: 5999 },
      { key: '3rd_sergeant', icon: '3-sargento.png', max: 7999 },
      { key: '2rd_sergeant', icon: '2-sargento.png', max: 9999 },
      { key: '1rd_sergeant', icon: '1-sargento.png', max: 11999 },
      { key: 'warrant_officer', icon: 'subtenente.png', max: 13999 },
      { key: 'aspirant', icon: 'aspirante.png', max: 15999 },
      { key: '2nd_lieutenant', icon: '2-tenente.png', max: 17999 },
      { key: '1nd_lieutenant', icon: '1-tenente.png', max: 19999 },
      { key: 'captain', icon: 'capitao.png', max: 21999 },
      { key: 'major', icon: 'major.png', max: 23999 },
      { key: 'lieutenant_colonel', icon: 'tenente-coronel.png', max: 25999 },
      { key: 'colonel', icon: 'coronel.png', max: 27999 },
      { key: 'attack_general', icon: 'general-de-ataque.png', max: 29999 },
      { key: 'stealth_general', icon: 'general-de-furtividade.png', max: 31999 },
      { key: 'general_of_intelligence', icon: 'general-de-inteligencia.png', max: 33999 },
      { key: 'marshal', icon: 'marechal.png', max: 39999 },
      { key: 'supreme_commander', icon: 'supremo-comandante.png', max: 49999 },
      { key: 'grand_marshal', icon: 'grao-marechal.png', max: 59999 },
      { key: 'warlord', icon: 'senhor-da-guerra.png', max: 69999 },
      { key: 'arconte', icon: 'arconte.png', max: 79999 },
      { key: 'supreme_leader', icon: 'lider-supremo.png', max: 89999 },
      { key: 'primordial', icon: 'primordial.png', max: 99999 },
      { key: 'hakai', icon: 'hakai.png', max: Infinity }
    ];

    const nextPatent = computed(() => {
      const lang = currentLanguage.value;
      const value = (user.value as { score?: { value: number } })?.score?.value ?? 0;
      const idx = PATENTS_ORDER.findIndex((p) => value <= p.max);
      const nextIdx = idx >= 0 && idx < PATENTS_ORDER.length - 1 ? idx + 1 : -1;
      if (nextIdx < 0) return null;
      const next = PATENTS_ORDER[nextIdx];
      return { name: t(`${lang}.patents.${next.key}`), icon: next.icon };
    });

    return {
      user,
      currentLanguage,
      store,
      Actions,
      hasFeature,
      isElite,
      progressToNextLevelPercent,
      nextPatent
    };
  },
});
